<ng-container #lazyLoadComponent></ng-container>
